module.exports = __webpack_public_path__ + "img/txt-2-f.40acf963.png";